// extracted by mini-css-extract-plugin
export default {"placeholderLink":"content_placeholder__placeholderLink__cBdhE","label":"content_placeholder__label__g_xPD","content":"content_placeholder__content__k0452"};